<app-block-wrapper [style]="style" [_editable]="_editable">
  <div class="reviews">
    @for (review of reviewData; track review) {
      <div class="review" [appStoryblok]="review._editable">
        <div class="stars">
          @for (star of review.stars; let i = $index; track i) {
            <div [class]="star"></div>
          }
        </div>

        <div class="text standard-text grey-70" [innerHTML]="review.text | storyblokRichText"></div>

        <div class="reviewer">
          @if (review.reviewerAvatar?.filename) {
            <img
              [src]="review.reviewerAvatar.filename + '/m/80x0/filters:quality(85)' | storyblokCdn"
              width="40"
              height="40"
              loading="lazy"
              alt=""
            />
          }
          <div class="reviewer-info" [class.no-image]="!review.reviewerAvatar?.filename">
            <div class="name">{{ review.reviewerName }}</div>

            @if (review.link) {
              <a
                [href]="review.link"
                class="role standard-text grey-70"
                target="_blank"
                rel="nofollow noreferrer noopener"
              >
                {{ review.reviewerRole }}
              </a>
            } @else {
              <div class="role standard-text grey-70">{{ review.reviewerRole }}</div>
            }
          </div>
        </div>
      </div>
    }
  </div>
</app-block-wrapper>
